export class Filtros {

  ParticipanteId: number;
  ProcessoId: number;
  constructor() {
    this.ParticipanteId = 0;
    this.ProcessoId = 0;
  }
}
